import { createContext, useContext } from 'react'
import { DISCIPLINES, type Discipline } from '@structural-climbing/validation'

// Which disciplines the viewed gym has, picked by a super admin. A
// bouldering-only gym shows no Lead wall, ranking or chart. Defaulted to both
// (never throws) like GymGradeConfigContext, so a screen still renders in
// isolation. GymLayout feeds it from the gym's /gym-info branding.
export const GymDisciplinesContext = createContext<readonly Discipline[]>(DISCIPLINES)

export function useGymDisciplines(): readonly Discipline[] {
  return useContext(GymDisciplinesContext)
}
